/**
 * AnimatedSection Component
 * Reusable wrapper for animated sections using Framer Motion
 */

import React, { useRef, useEffect } from 'react';
import { node, string } from 'prop-types';
import { motion, useAnimation, useInView } from 'framer-motion';
import { fadeInUp } from './animationVariants';

const AnimatedSection = ({ children, className = '' }) => {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.15 });

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [controls, isInView]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={fadeInUp}
      className={className}
    >
      {children}
    </motion.div>
  );
};

AnimatedSection.propTypes = {
  children: node.isRequired,
  className: string,
};

export default AnimatedSection;
